import { EonUiCheckbox } from "@eon-ui/eon-ui-components-react";

type CheckboxWithDescriptionProps = {
    label: string;
    value: boolean;
    description?: string;
    onValueChanged?: (checked: boolean) => void;
    disabled?: boolean; 
};

export const CheckboxWithDescription = ({label, value, description, onValueChanged, disabled = false}: CheckboxWithDescriptionProps) => {
    return (
        <div>
            <EonUiCheckbox label={label} size="small" checked={value} onValueChanged={() => onValueChanged?.(value)}  disabled={disabled}/>
            {description && <div style={{marginLeft: '28px'}}>{description}</div>}
        </div>
    );
};
